import { ACTIONS } from 'src/app/core/utils/actions.constants';
import { COMMONS } from 'src/app/core/utils/commons.constants';

export const VITAL_SIGN = {
  ...COMMONS,
  ...ACTIONS,

  id: 'general.vital-sign',
  title: 'Signos Vitales',

  patient: 'Paciente',
  editPatient: 'Editar información de paciente',
  measureDate: 'Toma de Signos Vitales',
  bornDate: 'Edad',
  temperature: 'Temperatura C',
  bloodPressure: 'Presión arterial (mm Hg.)',
  pulse: 'Pulso/min',
  breathingFrequency: 'Frecuencia respiratoria',
  weight: 'Peso Kg',
  height: 'Talla/cm',
  glucose: 'Glucosa (mg/dl)',
  oxygenSaturation: 'Saturación oxígeno',
  headCircumference: 'Perímetro cefálico/cm'
};
